import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from '../components/Login/Login';
import Dashboard from '../components/Dashboard/Dashboard';
import HtmlEditor from '../components/HtmlEditor/HtmlEditor';
import Toolbox from '../components/Toolbox/Toolbox';
import Counts from '../components/Counts/Counts';
import Zsbzs from '../components/Zsbzs/Zsbzs';

// 路由守卫组件
const ProtectedRoute = ({ children }) => {
  const userInfo = localStorage.getItem('userInfo');
  
  if (!userInfo) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// 登录页面守卫（已登录用户直接跳转到dashboard）
const LoginRoute = ({ children }) => {
  const userInfo = localStorage.getItem('userInfo');
  
  if (userInfo) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {/* 默认路由重定向到工具箱页面 */}
        <Route path="/" element={<Navigate to="/toolbox" replace />} />
        
        {/* 登录页面 */}
        <Route 
          path="/login" 
          element={
            <LoginRoute>
              <Login />
            </LoginRoute>
          } 
        />
        
        {/* 受保护的Dashboard页面 */}
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
        
        {/* HTML 编辑器页面（无需登录） */}
        <Route path="/html-editor" element={<HtmlEditor />} />

        {/* 工具箱页面（无需登录） */}
        <Route path="/toolbox" element={<Toolbox />} />

        {/* 访问次数统计页面 */}
        <Route path="/counts" element={<Counts />} />

        {/* zsbzs页面 */}
        <Route path="/zsbzs" element={<Zsbzs />} />

        {/* 404页面 */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;